var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SubmenuNav',{attrs:{"submenus":_vm.submenus,"generate-url":_vm.generateSubmenuPath},on:{"selected-clicked":_vm.selectedClicked}})}
var staticRenderFns = []

export { render, staticRenderFns }